const rules = {
  maxFileSize: (node: any, maxSizeMB: number) => {
    const files = node.value;
    if (!files || !Array.isArray(files)) return true;

    const totalFilesSize = files.reduce((acc, file: File) => {
      const fileSizeInMB = file.size / 1000 / 1000;
      return (acc += fileSizeInMB);
    }, 0);
    return totalFilesSize <= maxSizeMB;
  },
  fileSize: (node) => {
    const maxSize = node.props.maxFileSize;
    const maxSizeInBytes = maxSize * 1000 * 1000;
    const oversizedFiles = node.value.filter(
      (file) => file.size > maxSizeInBytes,
    );
    if (oversizedFiles.length > 0) {
      if (!node._oversizedFile) {
        node._oversizedFiles = [];
      }
      for (const oversizedFile of oversizedFiles) {
        node._oversizedFiles.push({
          name: oversizedFile.name,
          size: oversizedFile.size,
          maxSize: maxSize,
        });
      }
      return false;
    }
    return true;
  },
};
const messages = {
  fr: {
    maxFileSize: ({ args, node, name }) =>
      `La taille du fichier ne doit pas dépasser ${args[1]} MB`,
    fileSize: ({ node }) => {
      const maxSizeMB = Math.round(
        ((parseInt(node.props.maxFileSize) || 5) * 1000 * 1000) / (1000 * 1000),
      );
      return `Chaque photo doit faire au plus ${maxSizeMB - node.context.attrs.maxValue}MB`;
    },
  },
};
export { rules, messages };
